import { FC, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import RemoveMemberModal from '../components/RemoveMemberModal';
import RemoveMemberStore from '../stores/remove-member-store';
import { removeActiveMember } from '../actions/remove-member-actions';
import { closeRemoveMemberModal } from '../store-actions/remove-member-store-actions';

const RemoveMemberContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    isModalVisible,
    isLoading,
    selectedActiveMember,
    isLastAdminStanding,
    isActiveMemberAdmin,
    removeVerificationValue,
    activeMemberCount,
  } = useSnapshot(RemoveMemberStore);

  const { logout } = useAuth0();

  const onRemove = useCallback(async () => {
    if (!selectedActiveMember) {
      return;
    }
    await removeActiveMember(selectedActiveMember, logout);
  }, [logout, selectedActiveMember]);

  if (!isModalVisible) {
    return null;
  }

  return (
    <RemoveMemberModal
      open={isModalVisible}
      onClose={closeRemoveMemberModal}
      activeMember={selectedActiveMember}
      onRemove={onRemove}
      isLoading={isLoading}
      verificationValue={removeVerificationValue}
      isActiveMemberAdmin={isActiveMemberAdmin}
      isLastAdminStanding={isLastAdminStanding}
      activeMemberCount={activeMemberCount}
    />
  );
};

export default RemoveMemberContainer;
